//
//  FitinsightUserCsv.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import { ReactElement, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import dayjs from "dayjs";
import Box from "@mui/material/Box";
import { saveAs } from "file-saver";
import { getFitinsightUserList } from "../network/api";
import { FitinsightUser } from "../network/type";
import { isCompanyIdUsed } from "../utils/env";

const convertUsersToCsv = (users: FitinsightUser[]) => {
  const headers = isCompanyIdUsed
    ? ["company_id", "user_id"]
    : ["user_id"];
  const rows = users.map(
    (user: { companyId: string; fitinsightUniqueId: string }) => {
      return isCompanyIdUsed
        ? [user.companyId, user.fitinsightUniqueId].join(",")
        : [user.fitinsightUniqueId].join(",");
    }
  );
  return headers.join(",") + "\n" + rows.join("\n");
};

export const getFitinsightUserCsv = async (maxUserCount: number = 1000) => {
  const response = await getFitinsightUserList(1, maxUserCount);
  if (!response.data) throw new Error("");

  const users = response.data.users;
  const csvData = convertUsersToCsv(users);
  return csvData;
};

const FitinsightUserCsv = (): ReactElement => {
  const [alertMessage, setAlertMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleUserCSVDownload = async (): Promise<void> => {
    const csvData = await getFitinsightUserCsv().catch((_) => {
      setAlertMessage("エラーが発生しました");
    });
    if (csvData) {
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const blob = new Blob([bom, csvData], { type: "text/csv;charset=UTF-8" });
      const date = dayjs().format("YYYYMMDD");
      saveAs(blob, `連携済みユーザ一覧_${date}.csv`);
      setSuccessMessage(`${date}のデータをダウンロードしました`);
    }
  };
  useEffect(() => {
    if (!alertMessage && !successMessage) {
      return;
    }
    const timer = setTimeout(() => {
      setAlertMessage("");
      setSuccessMessage("");
    }, 3000);
    return () => clearTimeout(timer);
  }, [alertMessage, successMessage]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={3}
    >
      <Button
        id="donwloadFitinsightUserCsv"
        variant="outlined"
        color="primary"
        onClick={() => handleUserCSVDownload()}
        style={{ width: "150px", height: "50px", margin: 10 }}
      >
        csv出力
      </Button>
    </Box>
  );
};

export default FitinsightUserCsv;
